import React, { useEffect, useState } from 'react';
import GridLayout from './GridLayout';
import { useSelector, useDispatch } from 'react-redux';

import {
  editDashboards,
  enableTransitionDashboards,
  setCurrentDashboard
} from '../../redux/actions/dashboards';
import ModalChangeStatusBySupervisor from '../../components/ModalChangeStatusBySupervisor';

function Dashboard (props) {
  const dispatch = useDispatch();
  const dashboards = useSelector(state => state.dashboards);
  const dash = useSelector(state => state.dashboards.currentDash);
  const [modalShowChangeStatus, setModalShowChangeStatus] = useState(false);
  const [dataModalChangeStatus, setDataModalChangeStatus] = useState({});

  useEffect(() => {
    if (dashboards.enableTransition) {
      const minutes = dashboards.timeTransition.slice(0, 2) * 60000;
      const seconds = dashboards.timeTransition.slice(2, 4) * 1000;
      const milliseconds = minutes + seconds;
      const transitionMembers = dashboards.data.filter(dash => dash.transition);
      let dashPosition = 1;
      if (transitionMembers.length >= 2) {
        const lastPosition = transitionMembers.length - 1;
        const firstDash =
          dash._id !== transitionMembers[0]._id
            ? transitionMembers[0]
            : transitionMembers[lastPosition];
        dispatch(setCurrentDashboard({ ...firstDash }));
        const timer = setInterval(() => {
          if (transitionMembers.length > dashPosition) {
            ++dashPosition;
          } else {
            dashPosition = 1;
          }
          const newDash = {
            ...transitionMembers[dashPosition - 1]
          };
          dispatch(setCurrentDashboard(newDash));
        }, milliseconds);

        return () => {
          clearInterval(timer);
          // força a atualização dos grids
          const dash = dashboards.data.find(dash => dash.selected);
          dispatch(setCurrentDashboard({ ...dash, items: [] }));
          setTimeout(() => {
            dispatch(setCurrentDashboard({ ...dash }));
          }, 50);
        };
      } else {
        dispatch(enableTransitionDashboards(false));
      }
    }
  }, [dispatch, dashboards.enableTransition, dashboards.timeTransition]);

  const onResizeStop = layout => {
    const updateDash = {
      ...dash,
      items: dash.items.map((item, index) => {
        const { x, y, w, h, minW, minH } = layout[index];
        return { ...item, x, y, w, h, minW, minH };
      })
    };
    dispatch(editDashboards(updateDash));
  };

  const onDragStop = layout => {
    const updateDash = {
      ...dash,
      items: dash.items.map((item, index) => {
        const { x, y, w, h, minW, minH } = layout[index];
        return { ...item, x, y, w, h, minW, minH };
      })
    };
    dispatch(editDashboards(updateDash));
  };

  return (
    <React.Fragment>
      <ModalChangeStatusBySupervisor
        modalShowChangeStatus={modalShowChangeStatus}
        setModalShowChangeStatus={setModalShowChangeStatus}
        dataModalChangeStatus={dataModalChangeStatus}
        setDataModalChangeStatus={setDataModalChangeStatus}
      />
      <GridLayout
        {...props}
        onDragStop={onDragStop}
        onResizeStop={onResizeStop}
        modalShowChangeStatus={modalShowChangeStatus}
        setModalShowChangeStatus={setModalShowChangeStatus}
        dataModalChangeStatus={dataModalChangeStatus}
        setDataModalChangeStatus={setDataModalChangeStatus}
      />
    </React.Fragment>
  );
}

export default Dashboard;
